/** Текст уведомления, если ошибка не ApiError или сообщение пустое. */
export const DEFAULT_ERROR_NOTIFY_MESSAGE =
  'Не удалось выполнить операцию. Повторите попытку позже.'

const HTTP_STATUS_MESSAGES_RU: Record<number, string> = {
  400: 'Некорректный запрос',
  401: 'Требуется войти в систему',
  403: 'Доступ запрещён',
  404: 'Не найдено',
  405: 'Метод не разрешён',
  408: 'Истекло время ожидания запроса',
  409: 'Конфликт данных',
  413: 'Слишком большой объём данных',
  422: 'Ошибка проверки данных',
  429: 'Слишком много запросов. Подождите и повторите.',
  500: 'Внутренняя ошибка сервера',
  502: 'Сервер недоступен',
  503: 'Сервис временно недоступен',
  504: 'Превышено время ожидания ответа сервера',
}

const ENGLISH_HTTP_PHRASE_TO_RU: Record<string, string> = {
  'bad request': 'Некорректный запрос',
  unauthorized: 'Требуется войти в систему',
  forbidden: 'Доступ запрещён',
  'not found': 'Не найдено',
  'method not allowed': 'Метод не разрешён',
  'request timeout': 'Истекло время ожидания запроса',
  conflict: 'Конфликт данных',
  'payload too large': 'Слишком большой объём данных',
  'content too large': 'Слишком большой объём данных',
  'unprocessable entity': 'Ошибка проверки данных',
  'too many requests': 'Слишком много запросов',
  'internal server error': 'Внутренняя ошибка сервера',
  'bad gateway': 'Сервер недоступен',
  'service unavailable': 'Сервис временно недоступен',
  'gateway timeout': 'Превышено время ожидания ответа сервера',
  'network error': 'Ошибка сети',
  'failed to fetch': 'Нет соединения с сервером',
  'load failed': 'Не удалось выполнить запрос',
  'emergency mode is already active for this project':
    'Для этого проекта аварийный режим уже включён. Измените настройки в таблице выше или выберите другой проект.',
}

/**
 * Приводит текст ошибки API к русскому для показа в UI.
 * Сообщения с кириллицей оставляем как есть; типичные англоязычные фразы и «голый» HTTP-текст заменяем.
 */
export function formatUserApiError(status: number, rawMessage: string): string {
  const raw = (rawMessage || '').trim()
  if (raw && /[\u0400-\u04FF]/.test(raw)) return raw

  const lower = raw.toLowerCase()
  if (lower && ENGLISH_HTTP_PHRASE_TO_RU[lower]) {
    return ENGLISH_HTTP_PHRASE_TO_RU[lower]
  }

  if (!raw) {
    return HTTP_STATUS_MESSAGES_RU[status] || `Ошибка запроса (код ${status})`
  }

  if (!/[\u0400-\u04FF]/.test(raw) && /[a-zA-Z]/.test(raw)) {
    return (
      HTTP_STATUS_MESSAGES_RU[status] || 'Произошла ошибка. Повторите попытку позже.'
    )
  }

  return raw
}
